import { ALIGN, APP } from '_pixiSrc/globals';
import Sprite from '_pixiSrc/display/Sprite';
import I18 from '_pixiSrc/I18';
import { Utils } from '_pixiSrc/Utils';
import ScreenLocker from './ScreenLocker';
import Static from '../libraries/Static';
import Button from './Button';
import {
    ASSETS_PATH,
} from '../Constants';

class GlobalError extends Sprite {
    constructor(id, data = null, autoReload = true, buttonText = '', callback = () => { }) {
        super();

        console.error(id, data);

        this.autoReload = autoReload;

        const message = I18.f(`error_${id}`);
        const languages = ['en', 'de', 'es', 'fr', 'it', 'nl', 'pl', 'ru', 'tr', 'cs'];
        const GET = Utils.parseGet();
        let locale = GET.locale ? GET.locale.substr(0, 2) : '';
        if (languages.indexOf(locale) < 0) {
            locale = languages[0];
        }
        this.locale = locale;

        if (!APP.ready) {
            this.showHtml(message);
            return;
        }

        APP.currentWindow.ui.buttons.spin.closeAction();

        this.back = this.addChild(new ScreenLocker(0X270029, 0.9));

        // Static.writeText(this, I18.f("error"), 'font_gold5', 0, -100);
        const messageSprite = Static.writeNativeText(this, message, 'lato-regular', 0, 0, {
            align: ALIGN.CENTER,
            fill: 0Xffffff,
            dropShadow: true,
            dropShadowAngle: 0,
            dropShadowBlur: 12,
            dropShadowColor: 0Xff2fff,
            dropShadowDistance: 0,
            wordWrap: true,
            wordWrapWidth: 500,
            alignText: 'center',
            size: 21,
            stroke: 0X1c011c,
            strokeThickness: 1,
            padding: 12,
        });
        messageSprite.position.set(0, -messageSprite.height);

        const btnAssetName = buttonText === 'OK' ? 'error/ok' : 'error/btn-reload';
        const btnHitArea = buttonText === 'OK' ? new PIXI.RoundedRectangle(-75, -25, 152, 42, 15) : new PIXI.RoundedRectangle(-110, -25, 222, 42, 15);
        const btn = this.addChild(new Button(btnAssetName, 0, 50, 1, () => {
            callback();
            this.close();
        }));
        btn.hitArea = btnHitArea;

        btn.on('pointerdown', () => {
            if (btn.isDisabled) {
                return;
            }
            btn.isPointerDown = true;
            btn.gotoAndStop(2);
        });

        btn.on('pointerover', () => {
            if (btn.isDisabled) {
                return;
            }
            if (btn.isPointerDown) {
                btn.gotoAndStop(2);
            } else {
                btn.gotoAndStop(1);
            }
        });

        const myJackpotLogo = this.addChild(APP.library.getSprite('main/my-jackpot-logo'));
        myJackpotLogo.position.set(0, 200);
        myJackpotLogo.scale.set(0.8);
    }

    showHtml(message) {
        const container = document.getElementsByClassName('p2m-layer-screens')[0];

        if (container) {
            container.style.display = 'block';
            container.style.background = `url(${ASSETS_PATH.IMAGES}/1.5/error/error-background.png)`;
            container.style.backgroundSize = 'cover';
            container.style.backgroundPosition = '50%';
            APP.resizeDecor();

            const canvas = container.getElementsByTagName('canvas')[0];
            if (canvas) {
                canvas.style.visibility = 'hidden';
            }

            this.htmlWindow = document.createElement('div');
            this.htmlWindow.classList.add('error-window');

            let d = document.createElement('div');
            d.classList.add('error-message');
            d.innerHTML = message;
            this.htmlWindow.appendChild(d);
            this.htmlWindow._message = d;

            d = document.createElement('div');
            d.style.background = `url(${ASSETS_PATH.IMAGES}/1.5/error/${this.locale.toUpperCase()}/btn-reload.png)`;
            d.style.margin = 'auto';
            d.style.overflow = 'hidden';
            const actionArea = document.createElement('div');
            actionArea.style.cursor = 'pointer';
            d.appendChild(actionArea);
            this.htmlWindow.appendChild(d);
            this.htmlWindow._button = d;
            this.htmlWindow._buttonArea = actionArea;

            this.myJackpotLogo = container.appendChild(document.createElement('div'));
            this.myJackpotLogo.style.background = `url(${ASSETS_PATH.IMAGES}/1.5/main/my-jackpot-logo.png)`;
            this.myJackpotLogo.classList.add('my-jackpot-logo');

            actionArea.addEventListener('click', this.close.bind(this), false);
            actionArea.addEventListener('touchstart', this.close.bind(this), false);

            document.body.appendChild(this.htmlWindow);
        }

        this.resizeHtml();

        APP.layout.on('fitlayout', this.resizeHtml, this);
    }

    resizeHtml() {
        const container = document.getElementsByClassName('p2m-layer-screens')[0];
        if (container) {
            const canvas = container.getElementsByTagName('canvas')[0];
            if (canvas) {
                const scale = APP.layout.calculatedSize.scale;

                let w = Math.floor(500 * scale);
                let h = Math.floor(379 * scale);
                const myJackpotLogoWidth = 350 * scale;
                const myJackpotLogoHeight = 201 * scale;

                this.htmlWindow.style.width = `${w}px`;
                this.htmlWindow.style.height = `${h}px`;
                this.htmlWindow.style.marginLeft = `${-w / 2}px`;
                this.htmlWindow.style.backgroundSize = `${w}px ${h}px`;

                this.htmlWindow._message.style.fontSize = `${24 * scale}px`;
                this.htmlWindow._message.style.marginBottom = `${35 * scale}px`;

                w = Math.floor(245 * scale);
                h = Math.floor(65 * scale);
                this.htmlWindow._buttonArea.style.width = `${Math.floor(220 * scale)}px`;
                this.htmlWindow._buttonArea.style.height = `${Math.floor(40 * scale)}px`;
                this.htmlWindow._buttonArea.style.marginLeft = `${13 * scale}px`;
                this.htmlWindow._buttonArea.style.marginTop = `${9 * scale}px`;

                this.htmlWindow._button.style.fontSize = `${20 * scale}px`;
                this.htmlWindow._button.style.width = `${w}px`;
                this.htmlWindow._button.style.height = `${h}px`;
                this.htmlWindow._button.style.lineHeight = `${h}px`;
                this.htmlWindow._button.style.backgroundSize = `${w * 4}px ${h}px`;

                this.myJackpotLogo.style.width = `${myJackpotLogoWidth}px`;
                this.myJackpotLogo.style.marginLeft = `${-myJackpotLogoWidth / 2}px`;
                this.myJackpotLogo.style.height = `${myJackpotLogoHeight}px`;
                this.myJackpotLogo.style.marginTop = `${-myJackpotLogoHeight / 2 - 12 * scale}px`;
                this.myJackpotLogo.style.padding = `${scale * 2}px`;
            }
        }
    }

    close() {
        this.safeRemove();

        APP.glovalErrorView = null;

        if (this.autoReload) { window.location.reload(); }
    }
}

export default GlobalError;
